import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const EmailSenderVerification = lazy(() =>
  import("@scenes/EmailSenderVerification/EmailSenderVerification").then((module) => ({
    default: module.EmailSenderVerification,
  }))
);

export const senderVerificationNRO: NavigationRoutingObject = {
  Component: EmailSenderVerification,
  componentFeatureFlippers: ["self_service_email_setup"],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("sender-verification-menu-option", "Sender Verification"),
  pageNameForTracking: () => "Sender Verification",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    // Please keep this in sync with the logic in the SettingsMenuItems component
    // Hide when verified_domain is on — Email Self Serve uses the same "Sender Verification" page title
    if (!featureOn("self_service_email_setup") || featureOn("verified_domain")) {
      return false;
    }

    return hasPermission("company", {
      permission: "manageCompanySettings",
    });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
